module.exports = __webpack_public_path__ + "img/18_ABATTAGE-TAMARIN.eaac99c5.jpg";